import { TRANSACTIONS_LIST, PAYMENT_LIST, WITHDRAW_PENDING_LIST, WITHDRAW_UPDATE ,WITHDRAW_CANCEL} from 'App/store/constants';
const initialState = {
  transactions: null,
  withdrawList: null,
  cancelWithDrawnFlag: null,
  depositAmount: null,
  paymentList: null,
  errors: {},
  loading: false,
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case TRANSACTIONS_LIST.PENDING:
      return {...state, cancelWithDrawnFlag: null, loading: true};
 case TRANSACTIONS_LIST.SUCCESS:
  return {
    ...state,
    loading: false,
    zones: action.payload.data.zones,
    transactions:action.payload.data,
  }
    case TRANSACTIONS_LIST.FAILURE:
      return {
        ...state,
        transactions: null,
        loading: false,
        errors: action.payload,
      };
      case WITHDRAW_PENDING_LIST.PENDING:
        return {...state, cancelWithDrawnFlag: null, loading: true};
      case WITHDRAW_PENDING_LIST.SUCCESS:
        return {...state, loading: false, withdrawList: action.payload.data};
      case WITHDRAW_PENDING_LIST.FAILURE:
        return {
          ...state,
          withdrawList: null,
          loading: false,
          errors: action.payload,
        };

    case PAYMENT_LIST.PENDING:
      return { ...state, loading: true };
    case PAYMENT_LIST.SUCCESS:
      return { ...state, loading: false, paymentList: action.payload.data };
    case PAYMENT_LIST.FAILURE:
      return {
        ...state,
        paymentList: null,
        loading: false,
        errors: action.payload,
      };

   
      case WITHDRAW_UPDATE.PENDING:
        return {...state, cancelWithDrawnFlag: null, loading: true};
      case WITHDRAW_UPDATE.SUCCESS:
        return {...state, cancelWithDrawnFlag: true, loading: false};
      case WITHDRAW_UPDATE.FAILURE:
        return {
          ...state,
          loading: false,
          errors: action.payload,
        };
  
      case WITHDRAW_CANCEL.PENDING:
        return {...state, loading: true};
      case WITHDRAW_CANCEL.SUCCESS:
        return {...state, cancelWithDrawnFlag: true, withdrawList: null, loading: false};
      case WITHDRAW_CANCEL.FAILURE:
        return {
          ...state,
          loading: false,
          errors: action.payload,
        };
    default:
      return state;
  }
};

export default reducer;
